import { useContext } from "react";
import { ConversationDetailsContext } from "../../context";
import { ConversationTypeEnum } from "@coxauto-ui/cxm/communications/interfaces";
import { EmailChannelValueSelector } from "./email-channel-value-selector";
import { TextChannelValueSelector } from "./text-channel-value-selector";
import { PhoneChannelValueSelector } from "./phone-channel-value-selector";

export interface ChannelValueSelectorProps {
  isDisabled: boolean;
}

export function ChannelValueSelector(props: ChannelValueSelectorProps) {
  const { currentConversationType } = useContext(ConversationDetailsContext);

  switch (currentConversationType) {
    case ConversationTypeEnum.EMAIL:
      return <EmailChannelValueSelector {...props} />;

    case ConversationTypeEnum.TEXT:
      return <TextChannelValueSelector {...props} />;

    case ConversationTypeEnum.PHONE:
      return <PhoneChannelValueSelector {...props} />;

    default:
      return null;
  }
}

export default ChannelValueSelector;
